import { Heading, JsxStyleProps, Separator, VStack } from "@chakra-ui/react"
import { ReactNode, forwardRef } from "react"
import { COVER_PAGE_PADDING } from "./constants"

type CoverPageDividerProps = {
  title?: string
  renderTitle?: () => ReactNode
  verticalMargin?: JsxStyleProps["paddingTop"] | JsxStyleProps["paddingBottom"]
  horizontalMargin?:
    | JsxStyleProps["paddingLeft"]
    | JsxStyleProps["paddingRight"]
  titleMargin?: JsxStyleProps["marginTop"] | JsxStyleProps["marginBottom"]
}

const CoverPageDivider = forwardRef<HTMLDivElement, CoverPageDividerProps>(
  (
    {
      title,
      renderTitle,
      verticalMargin = "30px",
      horizontalMargin = COVER_PAGE_PADDING,
      titleMargin
    },
    ref
  ) => {
    return (
      <VStack
        ref={ref}
        className="CoverPageDivider"
        align="start"
        w="100%"
        gap={0}
        px={horizontalMargin}
        scrollMarginTop="20px"
      >
        <Separator
          my={verticalMargin}
          h="1px"
          border="none"
          bg="blackAlpha.200"
          w="100%"
        />
        {title || renderTitle ? (
          <Heading
            as="h3"
            // @ts-expect-error: TODO: get typing correct using chakra typegen https://chakra-ui.com/docs/get-started/cli#chakra-typegen
            size="h7"
            m={0}
            color="PRIMARY_GRAY"
            mb={titleMargin || verticalMargin}
            className="theme-heading theme-heading-semibold"
          >
            {renderTitle ? renderTitle() : title}
          </Heading>
        ) : null}
      </VStack>
    )
  }
)

export default CoverPageDivider
